// extracted by mini-css-extract-plugin
export default {"header":"Mechanics_header__Mu7xD"};